import React, { useState, useEffect } from 'react';
import './styles/velkommen.css';
import MainButton from './mainButton';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

// Simpel funktion til at konvertere basis markdown til HTML
const markdownToHtml = (markdown) => {
  if (!markdown) return '';

  // Konverter overskrifter
  let html = markdown.replace(/^## (.*?)$/gm, '<h3>$1</h3>');

  // Konverter fed tekst
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  // Konverter kursiv tekst
  html = html.replace(/_(.*?)_/g, '<em>$1</em>');
  
  // Konverter understregning
  html = html.replace(/__(.*?)__/g, '<u>$1</u>');

  // Konverter links - [text](url)
  html = html.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

  // Konverter bullet points
  html = html.replace(/^- (.*?)$/gm, '<li>$1</li>');
  html = html.split(/\n/).map(line => {
    if (line.startsWith('<li>')) {
      return line;
    }
    return line === '' ? '<br/>' : `<p>${line}</p>`;
  }).join('');

  // Wrap bullets i ul tags
  html = html.replace(/(<li>.*?<\/li>)+/g, '<ul>$&</ul>');

  // Fjern ekstra <br/> tags
  html = html.replace(/<p><br\/><\/p>/g, '<br/>');
  html = html.replace(/<br\/><br\/>/g, '<br/>');

  return html;
};

const Velkommen = () => {
  const [welcomeData, setWelcomeData] = useState({
    title: 'Velkommen til Psykologisk Perspektiv',
    content: '',
    htmlContent: ''
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchWelcomeText = async () => {
      try {
        const welcomeTextRef = doc(db, 'content', 'welcomeText');
        const welcomeTextSnap = await getDoc(welcomeTextRef);
        
        if (welcomeTextSnap.exists()) {
          const data = welcomeTextSnap.data();
          
          // Prioriter htmlContent hvis det findes, ellers konverter markdown til HTML
          const contentHtml = data.htmlContent || markdownToHtml(data.content || '');
          
          setWelcomeData({
            title: data.title || 'Velkommen til Psykologisk Perspektiv',
            content: data.content || '',
            htmlContent: contentHtml
          });
        }
      } catch (error) {
        console.error("Fejl ved hentning af velkomsttekst:", error);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchWelcomeText();
  }, []);

  if (isLoading) {
    return null; // Eller en loading indikator
  }

  return (
    <section className="pp-velkommen">
      <div className="pp-velkommen__container">
        <div className="pp-velkommen__content">
          <h2 className="pp-velkommen__title">{welcomeData.title}</h2>
          <div className="pp-velkommen__text" dangerouslySetInnerHTML={{ __html: welcomeData.htmlContent }} />
        </div>
        <div className="pp-velkommen__button-wrapper">
          <MainButton href="/om">Læs mere</MainButton>
        </div>
      </div>
    </section>
  );
};

export default Velkommen;
